import { PillSlot } from 'types/markerTypesV2/m-v2-core.js';
import { StatusRating } from 'utilities/status/status-rating.js';

/** `StatusRating` members are declared worst → best (`statusBad=1 … statusGood=4`) */
const RANK = Object.values(StatusRating);

export const getDotSlotIndex = (slots: readonly PillSlot[]): number =>
  slots.reduce((worst, slot, i) => {
    const rank = RANK.indexOf(slot.meta as StatusRating);
    const worstRank = RANK.indexOf(slots[worst].meta as StatusRating);
    return rank > 0 && (worstRank <= 0 || rank < worstRank) ? i : worst;
  }, 0);
